module.exports = __webpack_public_path__ + "static/media/PushImageFemale.0b393e0f.svg";